import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

const TableFilter = ({ store }) => {
    const changeValue = (event) => {
        store.query = event.target.value;
    };
    return (
        <div>
            <input
                type="text"
                className="form-control mb-2 mr-sm-2 mb-sm-0"
                placeholder="Search"
                name="tableLimit"
                onChange={changeValue} />
        </div>);
};


TableFilter.propTypes = {
    store: PropTypes.object.isRequired,
};

export default (observer(TableFilter));
